// === Tag axios failures with the request they belong to ===
// Every failed XHR is reported to Sentry as the same "AxiosError: Network Error"
// group with no URL on it, so the failing endpoint cannot be told apart.
// Only host + path are tagged (no query string), so no user data is attached.
export const tagAxiosError = (event, hint) => {
	const error = hint?.originalException;
	if (!error?.isAxiosError) return event;

	let endpoint = error.config?.url;
	try {
		const url = new URL(endpoint, window.location.href);
		endpoint = url.host + url.pathname;
	} catch (e) {
		// Unparseable url — keep it as given.
	}

	event.tags = {
		...event.tags,
		"axios.endpoint": endpoint || "unknown",
		"axios.method": (error.config?.method || "unknown").toUpperCase(),
		"axios.status": String(error.response?.status ?? 0),
		"axios.code": error.code || "unknown",
		"navigator.online": String(navigator.onLine),
	};
	return event;
};
